<div class="_relative _w-full">
    <fieldset class="_w-full _input-rounded _relative _bg-transparent" 
        [ngClass]="{'_border-transparent' : chooseGuestsActive || !border}">
        <div [ngClass]="{
            '_input-rounded _h-form-field-fat _bg-transparent _border-primary-1 _center-xy-absolute _outline-inset _shadow' : chooseGuestsActive,
            '_hidden' : !chooseGuestsActive
            }"
            [ngStyle]="{ 'width' : 'calc(100% + 2px)' }">
        </div>
        <label for="guestsSelector" class="_cursor-pointer">
            <i class="fa-light fa-family _mr-2"></i>
        </label>
        <input id="guestsSelector"
            class="_input-reset _cursor-pointer _w-full _h-full _overflow-ellipsis"
            [ngClass]="{'_absolute _opacity-0 _hidden _left-0' : !showTotalGuests}"
            type="number" 
            readonly
            placeholder="Add guests" 
            [formControl]="guestsControl"
            (click)="chooseGuestsActive = true">

        <div *ngIf="!showTotalGuests && (guestsRestrictions$ | async) as guestsRestrictions" 
            class="_flex _items-center _w-full _h-full _cursor-pointer '_absolute _top-0 _left-0 _overflow-ellipsis" 
            (click)="chooseGuestsActive = true">
            <ng-container *ngFor="let criterion of guestCriterion | keyvalue; let first = first">
                <span *ngIf="criterion.value !== 0" class="_flex _w-max">
                    <span *ngIf="!first" class="_mr-1">, </span>
                    <div [ngSwitch]="ageGroupsKeyValueMap[criterion.key].toLowerCase()">
                        <div *ngSwitchCase="'adults'">{{criterion.value}} {criterion.value, plural, =1 {adult} other {adults}}</div>
                        <div *ngSwitchCase="'children'">{{criterion.value}} {criterion.value, plural, =1 {child} other {children}}</div>
                        <div *ngSwitchCase="'infants'">{{criterion.value}} {criterion.value, plural, =1 {infant} other {infants}}</div>
                        <div *ngSwitchDefault> {{criterion.value}} {{ageGroupsKeyValueMap[criterion.key].toLowerCase()}}</div>
                    </div>                    
                </span>
            </ng-container>
        </div>

        <i [ngClass]="{ 
                '_text-primary-1-tint-20 _pointer-events-none _cursor-default' : totalGuests === 1, 
                '_cursor-pointer' : totalGuests > 1
            }"
            class="fa-light fa-xmark _z-10" 
            (click)="clearAll()"></i>
    </fieldset> 
    <div *ngIf="formGroup && chooseGuestsActive && (guestsRestrictions$ | async) as guestsRestrictions"
        class="_border _border-primary-1 _bg-white _mt-4 _rounded-lg _p-4 _overflow-scroll _no-scrollbar"
        [ngClass]="{ '_absolute _w-full _min-w-max _z-10 _shadow' : !inline }">
        <form [formGroup]="formGroup" class="_flex _flex-col _gap-4">

            <ng-container *ngFor="let ageRange of guestsRestrictions.ageRanges">
                <div class="_flex _items-center _justify-between _relative">

                    <div>
                        <span>{{ ageRange.labelPrefix }}</span>
                        <span class="_ml-1 _text-sm _text-primary-1-tint-50">
                            <ng-container *ngIf="ageRange.maxAge !== 0">
                                ({{ ageRange.minAge }} - {{ ageRange.maxAge}} years)
                            </ng-container>
                            <ng-container *ngIf="ageRange.maxAge === 0">
                                ({{ ageRange.minAge }} years and over)
                            </ng-container>
                        </span>
                    </div>
                    <div class="_flex _items-center _ml-4 _relative">
                        <div [ngClass]="!ageRange.allowed ? '_mask _opacity-70 _cursor-not-allowed ' : '_hidden'">
                            <div class="_tooltip _w-full _h-full">
                                <span class="_tooltiptext _tooltip-x-above _tooltip-y-right">This property does not allow for guests in this age group.</span>
                            </div>
                        </div>
                        <app-flok-number-input 
                            [formControlName]="ageRange.key" 
                            [max]="ageRange.maxNumberAllowed === 0 && ageRange.key === 'adults' ? maxGuests : ageRange.maxNumberAllowed === 0 ? 30 : ageRange.maxNumberAllowed"
                            [min]="ageRange.minNumberAllowed">
                        </app-flok-number-input> 
                        <span class='_ml-2 _cursor-pointer' (click)="clearFilters(ageRange.key)">
                            <i class="fa-light fa-arrows-rotate _text-primary-1-tint-20"></i>
                        </span>
                    </div>  
                </div>
            </ng-container> 
        </form>
    </div>

    <div *ngIf="maxOccupancyReached" class="_flex _items-center _justify-center _text-yellow-600 _text-sm _text-center _mt-2">
        <i class="fa-light fa-circle-exclamation _text-yellow-600 _mr-1"></i>
        <span>Maximum occupancy has been reached</span>
    </div>

    <div *ngIf="maxOccupancyExceeded" class="_flex _items-center _justify-center _text-error-red _text-sm _text-center _mt-2">
        <i class="fa-light fa-circle-exclamation _text-yellow-600 _mr-1"></i>
       <span>Maximum occupancy has been exceeded</span> 
    </div>

</div>

